import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "../../../core/services/protocols/types";
import { IAdicionarEmpresaParams, IAdicionarEmpresaResponse } from "./types";
import { inject, injectable } from "inversify";
import { IAdicionarEmpresaGateway } from "./IAdicionarEmpresaGateway";

@injectable()
export default class AdicionarEmpresaRequest
  implements IAdicionarEmpresaGateway
{
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async handleSolicitarEmpresa(
    params: IAdicionarEmpresaParams
  ): Promise<IAdicionarEmpresaResponse | undefined> {
    const response = await this.httpClient.post<IAdicionarEmpresaResponse>({
      url: "/v1/empresa/request-new-companies",
      body: { ...params }
    });

    if (!response.body) return undefined;

    return response.body;
  }
}
